var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [
        "gfu-block-editor",
        _vm.themeClass,
        { "gfu-block-editor--nohover": _vm.noHover },
      ],
    },
    [
      _c(
        "div",
        { staticClass: "gfu-block-editor__holder" },
        [
          _vm._t("prefix"),
          _vm._v(" "),
          _c("div", { staticClass: "gfu-block-editor__content-wrapper" }, [
            _vm.labels.length > 0 || _vm.$slots.labels
              ? _c(
                  "div",
                  { staticClass: "gfu-block-editor__tags" },
                  [
                    _vm._t("labels"),
                    _vm._v(" "),
                    _vm._l(_vm.labels, function (label) {
                      return _c(
                        "base-badge",
                        {
                          key: label.name,
                          staticClass: "_mr-1 _my-1",
                          attrs: {
                            theme: label.theme,
                            "data-qa": `badge:${label.theme}-${label.name}`,
                          },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(label.name) +
                              "\n                "
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { class: _vm.contentClass }, [_vm._t("default")], 2),
          ]),
        ],
        2
      ),
      _vm._v(" "),
      _vm.$slots.actions
        ? _c(
            "div",
            { staticClass: "gfu-block-editor__actions" },
            [_vm._t("actions")],
            2
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }